export const loginTestID = {
    button: 'authenticate-button',
}
